import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MessageService, SharedModule } from 'primeng/api';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import Detail from '../../../../../../types/detail/Detail';
import SampleCategory from '../../../../../../types/sample-category/SampleCategory';
import { DetailService } from '../../../../services/detail.service';
import { SampleCategoryService } from '../../../../services/sample-category.service';

@Component({
    selector: 'app-add-details-to-category-dialog',
    imports: [
        Button,
        Dialog,
        SharedModule,
        TableModule,
    ],
    templateUrl: './add-details-to-category-dialog.component.html',
    styleUrl: './add-details-to-category-dialog.component.scss'
})
export class AddDetailsToCategoryDialogComponent implements OnChanges {
    @Input() visible: boolean = false;
    @Input() category: SampleCategory | null = null;
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() saved: EventEmitter<any> = new EventEmitter<any>();

    public saving = false;
    public details: Detail[] = [];
    public selectedDetails: Detail[] = [];

    constructor(private detailService: DetailService,
                private categoryService: SampleCategoryService,
                private messageService: MessageService) {
    }

    public close(): void {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['visible'] && changes['visible'].currentValue) {
            this.loadDetails();
        }
    }

    public loadDetails(): void {
        this.detailService.getDetailsNotInCategory(this.category!.id).then(
            (details: Detail[]) => {
                this.details = details;
            }
        ).catch(error => {
            this.messageService.add(
                { severity: 'error', summary: 'Error', detail: error.message });
        });
    }

    public save() {
        this.saving = true;
        this.categoryService.addDetailsToCategory(this.category!.id, this.selectedDetails.map(d => d.id)).then(
            () => {
                this.saved.emit();
                this.close();
            }
        ).catch(error => {
            this.messageService.add(
                { severity: 'error', summary: 'Error', detail: error.message });
        }).finally(() => {
            this.saving = false;
        });
    }
}
